import { apiFetch } from "./apiClient";

/**
 * TEMPORARY: one-off initial data import. Admin only.
 *
 * The invoices ship as several ZIPs (one per transaction group), so every archive is appended
 * under the same "zip" part and the backend merges them into a single code -> PDF map.
 */
export function runSetupImport({
    excelFile,
    zipFiles = [],
    replaceExisting = true,
    requireInvoice = true,
}) {
    const formData = new FormData();
    formData.append("excel", excelFile);
    zipFiles.forEach((file) => formData.append("zip", file));
    formData.append("replaceExisting", String(replaceExisting));
    formData.append("requireInvoice", String(requireInvoice));

    return apiFetch("/setup-import/transaction-plans", {
        method: "POST",
        body: formData,
    });
}
